import Card from '@/components/Card/Card';
import B2BRadioCard, { B2BRadioCards } from '@/components/b2BRadioCard/B2BRadioCard';
import { SwdRadioGroup } from '@/components/swdRadioGroup/SwdRadioGroup';
import { EventCategory } from '@/helper/tracking';
import type { PatialB2BLoadProfileStoryblok } from '@/types/component-types-sb';
import { useFormikContext } from 'formik';

import classes from './B2BLoadProfiles.module.scss';
import type { B2BFormData } from './PageB2B';

type LoadProfilesProps = {
  loadProfiles: PatialB2BLoadProfileStoryblok[];
  headline?: string;
};

const B2BLoadProfiles: React.FC<LoadProfilesProps> = ({ loadProfiles, headline }) => {
  const formik = useFormikContext<B2BFormData>();

  return (
    <div className={classes.B2BLoadProfiles}>
      <Card className={classes.Card} variant="Box">
        {!!headline && <h2 className={classes.Headline}>{headline}</h2>}

        <SwdRadioGroup
          name="loadProfile"
          value={formik.values.loadProfile}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
        >
          <B2BRadioCards>
            {loadProfiles.map((item, index) => (
              <B2BRadioCard
                dataTestId={'B2B-load-profile-radio' + Number(index + 1)}
                key={item.key}
                name="loadProfile"
                checked={formik.values.loadProfile}
                value={item.key}
                headline1={item.headline_1}
                headline2={item.headline_2}
                subtitle1={item.subtitle_1}
                subtitle2={item.subtitle_2}
                infoContent={item.info_content}
                description={item.description}
                trackingCategory={EventCategory.B2B}
                trackingLabel={item.headline_1}
              />
            ))}
          </B2BRadioCards>
        </SwdRadioGroup>
      </Card>
    </div>
  );
};

export default B2BLoadProfiles;
